var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 58,
    viewBox: "0 0 49 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7021 1.05859C22.4565 4.24604 7.47928 10.7801 1.6001 10.7801V33.8688C1.6001 44.7229 23.4056 56.599 24.6888 56.9417C25.972 56.599 47.7775 43.8942 47.7775 35.084V10.7801C41.3636 10.7801 26.9466 4.24604 24.7021 1.05859Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0983 41.5041C40.8459 38.9096 42.9166 36.1524 42.9166 33.7609V14.7419C37.8529 14.7419 26.4714 9.62834 24.6984 7.13477C23.9827 8.14215 21.6252 9.57852 18.7646 10.931",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6889 13.0342C10.8782 14.0416 8.17798 14.7415 6.46094 14.7415V32.8102C6.46094 41.3044 23.6766 50.614 24.6889 50.8814C25.1482 50.7599 28.9384 48.6333 32.9436 45.7204",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.119 26.5776V21.7168H22.2582V26.5776H17.3975V31.4383H22.2582V36.2991H27.119V31.4383H31.9798V26.5776H27.119Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.10ce63d6877d4dfab67d265d8079167a.svg";
export { ForwardRef as ReactComponent };